const ACTION_PREPEND = 'purchase/vehicle';
export const UPDATE_VEHICLE_ID_AND_OR_STOCK_NUMBER_FROM_URL = `${ACTION_PREPEND}/UPDATE_VEHICLE_ID_AND_OR_STOCK_NUMBER_FROM_URL`;

export const GET_VEHICLE_ID_FROM_STOCK_NUMBER = `${ACTION_PREPEND}/GET_VEHICLE_ID_FROM_STOCK_NUMBER`;
